<template>
  <section class="section bg-light">
    <div class="container text-center">
      <h2>Warum zahlt die gesetzliche Rentenversicherung immer weniger aus?</h2>
      <p>
        Der medizinische Fortschritt und ein deutlicher Rückgang der Geburten sorgen dafür,
        dass die Bevölkerung in Deutschland immer älter wird.<br>
        Die Zahlung einer auskömmlichen Rente wird für den Staat künftig immer schwieriger
        und private Vorsorge somit immer wichtiger.
      </p>
      <div class="flex flex-wrap -mx-4 mt-7">
        <div class="w-full sm:w-5/12 xl:w-1/4 px-4 flex flex-col justify-between items-center">
          <p><strong>Ø Anzahl der Geburten je Frau</strong></p>
          <SvgVue icon="bedarfsinfo/altersvorsorge/geburten-je-frau" />
        </div>
        <div class="w-full sm:w-1/6 xl:w-1/12 px-4 justify-center self-center">
          <i class="fas fa-plus fa-3x my-5 xl:my-0" />
        </div>
        <div class="w-full sm:w-5/12 xl:w-1/4 px-4 flex flex-col justify-between items-center">
          <p><strong>Rentenbezugsdauer</strong></p>
          <SvgVue icon="bedarfsinfo/altersvorsorge/rentenbezugsdauer" />
        </div>
        <div class="w-full xl:w-1/12 px-4 justify-center self-center">
          <!-- Hier stand `d-xl-block`, eine nie definierte Bootstrap-Klasse: das
               Element ist seit jeher ausgeblendet. Als `xl:block` wäre es plötzlich
               sichtbar - das ist eine Design-Entscheidung, keine CSS-Aufräumung. -->
          <div class="hidden">
            <i class="fas fa-arrow-right fa-3x" />
          </div>
          <div class="block xl:hidden mb-5">
            <i class="fas fa-arrow-down fa-3x" />
          </div>
        </div>
        <div class="w-full xl:w-1/3 px-4">
          <div class="flex flex-wrap -mx-4 items-center">
            <div class="w-full md:w-1/2 xl:w-full px-4 md:text-left xl:text-center">
              <strong>Rentenlast in 2030</strong>
              <p>Zwei Beschäfigte müssen die monatliche Rente für einen Rentner finanzieren.</p>
            </div>
            <div
              ref="finance"
              class="w-full md:w-1/2 xl:w-full px-4"
            >
              <div class="px-2.5 sm:px-0">
                <div
                  v-for="({year, people}, i) in rentenFinanzierung"
                  :key="year"
                  class="flex flex-wrap -mx-4 bg-white sm:mb-0"
                  :class="{ 'mb-2.5': isLastIndex(i, rentenFinanzierung) }"
                >
                  <div class="w-full sm:w-1/6 bg-secondary text-white p-2.5">
                    {{ year }}
                  </div>
                  <div class="w-1/2 sm:w-5/12 p-2.5 text-right">
                    <i
                      v-for="j in people"
                      :key="j + people"
                      class="fas fa-user"
                    >asd</i>
                  </div>
                  <div class="w-1/3 sm:w-1/4 p-2.5">
                    <span class="inline-block rounded-full bg-secondary px-[0.6em] py-[0.25em] text-[75%] font-bold leading-none text-center text-white align-baseline whitespace-nowrap print:border print:border-black">{{ people }}</span>
                    <span class="mx-1">:</span>
                    <span class="inline-block rounded-full bg-secondary px-[0.6em] py-[0.25em] text-[75%] font-bold leading-none text-center text-white align-baseline whitespace-nowrap print:border print:border-black">1</span>
                  </div>
                  <div class="w-1/6 p-2.5 text-left">
                    <i class="fas fa-user" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { dom } from '@fortawesome/fontawesome-svg-core';
import { onMounted, ref } from 'vue';
import SvgVue from "@/application/components/SvgVue";

const finance = ref(null);

const rentenFinanzierung = [
  { year: 2030, people: 2 },
  { year: 2010, people: 3 },
  { year: 1975, people: 4 },
  { year: 1955, people: 5 },
];

function isLastIndex<T>(index: number, iterable: Iterable<T>): boolean {
  return index === [...iterable].length - 1;
}

onMounted(() => {
  if (finance.value !== null) dom.i2svg({ node: finance.value });
});
</script>
